import { com } from '@eidu/form'
import React, { useState } from 'react'
import { Button, Card, Stack } from '@mui/material'
import EntityTypeField from '../../pages/permission/path/EntityTypeField'
import { RenderablePath } from '../../pages/permission/path/PathField'
import ComplexPathField from './ComplexPathField'
import useRenderablePaths from '../misc/useRenderablePaths'
import useCreateSemanticLink from '../../io/useCreateSemanticLink'
import SemanticLinkConfig from '../../types/SemanticLinkConfig'
import EntityType = com.eidu.sharedlib.entity.type.EntityType
import EntityTypeId = com.eidu.sharedlib.entity.type.EntityTypeId
import EntityPath = com.eidu.sharedlib.entity.path.EntityPath

type SemanticLinkFieldProps = {
  entityType: EntityTypeId
  entityTypes: readonly EntityType[]
  semanticLinkConfig: SemanticLinkConfig
  onSave: () => void
  onCancel: () => void
}

const SemanticLinkField = ({
  entityType,
  entityTypes,
  semanticLinkConfig,
  onSave,
  onCancel,
}: SemanticLinkFieldProps) => {
  const availableTargetEntityTypes = entityTypes.filter(({ kind }) =>
    semanticLinkConfig.toTypeKind ? kind.equals(semanticLinkConfig.toTypeKind) : true
  )
  const [selectedTargetTypeId, setSelectedTargetTypeId] = useState(availableTargetEntityTypes.at(0)?.id)
  const [selectedPath, setSelectedPath] = useState<EntityPath>()
  const { save, isSaving } = useCreateSemanticLink(onSave)

  const targetType =
    selectedTargetTypeId && entityTypes.find(({ id: entityTypeId }) => entityTypeId === selectedTargetTypeId)

  const renderablePaths: RenderablePath[] = useRenderablePaths(entityType, targetType, entityTypes)

  const handleSave = () => {
    if (selectedPath) save(semanticLinkConfig.key, selectedPath)
  }

  return (
    <Card>
      <Stack padding={2} spacing={2}>
        <EntityTypeField
          entityTypeId={selectedTargetTypeId}
          onChange={(type) => {
            setSelectedTargetTypeId(type.id)
            setSelectedPath(undefined)
          }}
          types={availableTargetEntityTypes}
          label="Target type"
        />
        <ComplexPathField
          entityTypeId={entityType}
          targetType={targetType}
          selectedPath={selectedPath}
          setSelectedPath={setSelectedPath}
          renderablePaths={renderablePaths}
          fieldType={semanticLinkConfig.fieldType}
        />
        <Stack direction="row" spacing={2} justifyContent="flex-end">
          <Button variant="outlined" onClick={onCancel} disabled={isSaving}>
            Cancel
          </Button>
          <Button variant="contained" onClick={handleSave} disabled={isSaving || !selectedPath}>
            Save
          </Button>
        </Stack>
      </Stack>
    </Card>
  )
}

export default SemanticLinkField
